import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngxs/store';
import { Subject, take } from 'rxjs';
import { ClearReports } from '../../../reports/state/report.actions';
import { DigitizePointDialogComponent } from './dialog/digitize-point-dialog.component';
import { DigitizePointService } from './digitize-point.service';

@Injectable({
    providedIn: 'root'
})
export class DigitizePointLauncherService {

    constructor(
        private dialog: MatDialog,
        private store: Store,
        private snackBar: MatSnackBar,
        private digitizePointService: DigitizePointService
    ) {}

    enableDigitize(finishedSignal$?: Subject<void>) {
        let selectedLayer: string;
        this.digitizePointService.potentiallyDigitizableLayers$.pipe(take(1)).subscribe((potentiallyDigitizableLayers) => {
            if (potentiallyDigitizableLayers.length > 1) {
                // show choice dialog
                const dialogData = {
                    width: '400px',
                    autoFocus: true,
                    disableClose: true,
                    data: {
                        layers: potentiallyDigitizableLayers
                    }
                };
                const dialogRef = this.dialog.open(DigitizePointDialogComponent, dialogData);
                dialogRef.afterClosed().subscribe((result: string) => {
                    if (result) {
                        selectedLayer = result;
                        this.store.dispatch(new ClearReports({ type: 'feature' }));
                        this.digitizePointService.addPoint(selectedLayer, finishedSignal$);
                    }
                });
            } else if (potentiallyDigitizableLayers.length === 0) {
                // Can't do it
                const message = 'No digitizable layers configured. Contact your DashGIS Administrator.';
                this.snackBar.open(message, '', {
                    duration: 5000
                });
                finishedSignal$?.next();
            } else {
                selectedLayer = potentiallyDigitizableLayers[0].layer;
                this.digitizePointService.addPoint(selectedLayer, finishedSignal$);
            }
        });
    }

}
